import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { combineValidators, isRequired } from 'revalidate';
import {
  Button,
  Col,
  Form,
  FormGroup,
  FormInput,
  Modal,
  ModalBody,
  ModalHeader,
  Row
} from 'shards-react';
import {
  addContact,
  deleteCompany,
  updateCompany
} from '../../../../pages/Agents/agentActions';
import SelectInput from '../../../form/SelectInput';
import { STATE_DATA } from '../../../form/states.data';
import TelInput from '../../../form/TelInput';
import TextInput from '../../../form/TextInput';
import { closeModal } from '../../modalActions';

const mapState = (state, ownProps) => ({
  profile: state.firebase.profile,
  initialValues: ownProps.company,
  company: ownProps.company || {}
});

const actions = {
  closeModal,
  updateCompany,
  deleteCompany,
  addContact
};

const validate = combineValidators({
  displayName: isRequired('display name'),
  email: isRequired('email'),
  password: isRequired('password')
});

class AddNewCompany extends Component {
  state = {
    statesArray: STATE_DATA,
    contact_name: '',
    contact_email: '',
    contact_contact: '',

    company: {
      name: '',
      createdBy: { name: '', role: '', uid: '' },
      contactPersons: []
    },
    addMoreContactToggle: false
  };

  componentDidMount() {
    if (this.props.company) {
      //console.log('triggered');
      this.setState({ company: this.props.company });
    }
  }

  handleNewContact = e => {
    let contact = {
      name: this.state.contact_name,
      email: this.state.contact_email,
      contact: this.state.contact_contact,
      createdBy: {
        name: this.props.profile.displayName,
        uid: this.props.profile.uid,
        role: this.props.profile.role
      }
    };
    let newCompany = this.state.company;
    //console.log(newCompany, this.state);

    this.props.dispatch(addContact(contact, this.state.company));

    if (newCompany.contactPersons && newCompany.contactPersons.length > 0) {
      newCompany.contactPersons.push(contact);
    } else {
      newCompany.contactPersons = [];
      newCompany.contactPersons.push(contact);
    }

    this.setState({ company: newCompany });

    //this.state.company.contactPersons.push(contact);
    this.setState({ contact_name: '', contact_email: '', contact_contact: '' });
  };

  deleteContact = item => {
    //	console.log(item);

    let newCompany = this.state.company;
    newCompany.contactPersons = this.props.company.contactPersons.filter(
      element => element !== item
    );
    this.setState({ company: newCompany });
    this.props.dispatch(updateCompany(this.state.company));
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    const {
      closeModal,
      handleSubmit,
      error,
      company,
      pristine,
      submitting,
      deleteCompany,
      updateCompany,
      invalid
    } = this.props;
    const { statesArray, addMoreContactToggle } = this.state;
    return (
      <Modal
        className='col-md-8 col-lg-8'
        open={true}
        toggle={closeModal}
        modalClassName='modal'
        fade={true}
        role='dialog'
      >
        <ModalHeader className='bg-primary1'>
          {company.id ? 'Update Company' : 'Add New Company'}
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit(updateCompany)}>
            <strong className='mr-1'>Company Details</strong>
            <Row form>
              <Col>
                <FormGroup className='text-left'>
                  <label htmlFor='name'>Company Name</label>
                  <Field
                    name='name'
                    type='text'
                    placeholder='Enter Company Name'
                    component={TextInput}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <label htmlFor='companyName'>General Email 1</label>
                  <Field
                    name='email'
                    type='email'
                    placeholder='Enter Company General Email'
                    component={TextInput}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row form>
              <Col className='form-group'>
                <label htmlFor='companyTel'>General Line</label>
                <Field
                  name='companyTel'
                  type='tel'
                  component={TelInput}
                  placeholder='Enter a valid phone number with area code e.g: 07, 03'
                />
              </Col>
              <Col className='form-group'>
                <label htmlFor='companyFax'>Fax</label>
                <Field
                  name='companyFax'
                  type='tel'
                  component={TelInput}
                  placeholder='Enter a valid phone number with area code e.g: 07, 03'
                />
              </Col>
            </Row>
            <Row form>
              <Col className='form-group'>
                <FormGroup>
                  <label htmlFor='companyAddress1'>Address Line 1</label>
                  <Field
                    component={TextInput}
                    type='text'
                    name='companyAddress1'
                    placeholder={''}
                  />
                </FormGroup>
              </Col>
              <Col className='form-group'>
                <FormGroup>
                  <label htmlFor='companyAddress2'>Address Line 2</label>
                  <Field
                    component={TextInput}
                    type='text'
                    name='companyAddress2'
                    placeholder={''}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row form>
              <Col md='4' className='form-group'>
                <label htmlFor='companyAddressTown'>Town</label>
                <Field
                  component={TextInput}
                  name='companyAddressTown'
                  type='text'
                  placeholder={''}
                />
              </Col>
              <Col md='6' className='form-group'>
                <label htmlFor='companyAddressState'>State</label>
                <Field
                  component={SelectInput}
                  name='companyAddressState'
                  options={statesArray}
                  type='text'
                  placeholder={''}
                />
              </Col>
              <Col md='2'>
                <label htmlFor='companyAddressPostCode'>PostCode</label>
                <Field
                  name='companyAddressPostCode'
                  type='text'
                  component={TextInput}
                  placeholder={''}
                />
              </Col>
              <Col md='4'>
                <label htmlFor='companyWebsite'>Website</label>
                <Field
                  name='companyWebsite'
                  type='text'
                  className='text-lowercase'
                  component={TextInput}
                  placeholder={''}
                />
              </Col>
            </Row>
            {company.id && company.id.length > 0 ? (
              <Fragment>
                <strong className='mr-1'>Contacts</strong>
                <Row form>
                  <Col>
                    <Button
                      disabled={invalid}
                      className='float-right'
                      onClick={() =>
                        this.setState({
                          addMoreContactToggle: !addMoreContactToggle
                        })
                      }
                    >
                      Add Contact Person
                    </Button>
                  </Col>
                </Row>
              </Fragment>
            ) : (
              ''
            )}

            {company.contactPersons && company.contactPersons.length > 0 ? (
              <table className='table mb-0 mt-2'>
                <thead className='bg-light'>
                  <tr>
                    <th scope='col' className='border-0'>
                      Name
                    </th>
                    <th scope='col' className='border-0'>
                      Email
                    </th>
                    <th scope='col' className='border-0'>
                      Contact
                    </th>

                    <th scope='col' className='border-0'>
                      Created
                    </th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {company.contactPersons.map(contact => (
                    <tr>
                      <td> {contact.name}</td>
                      <td>{contact.email}</td>
                      <td>{contact.contact}</td>
                      <td>{contact.createdBy.name}</td>
                      <td>
                        <Button
                          theme='warning'
                          onClick={() => this.deleteContact(contact)}
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <Row form>
                <Col className='mr-2'>No Contacts</Col>
              </Row>
            )}
            {addMoreContactToggle && !invalid ? (
              <Row className='mt-2'>
                <Col>
                  <FormInput
                    name='contact_name'
                    type='text'
                    value={this.state.contact_name}
                    component={TextInput}
                    placeholder="Agent's name"
                    onChange={this.handleChange}
                  />
                </Col>
                <Col>
                  <FormInput
                    name='contact_email'
                    type='email'
                    value={this.state.contact_email}
                    component={TextInput}
                    placeholder='Direct email'
                    onChange={this.handleChange}
                  />
                </Col>
                <Col>
                  <FormInput
                    name='contact_contact'
                    type='tel'
                    value={this.state.contact_contact}
                    component={TelInput}
                    placeholder='Direct line'
                    onChange={this.handleChange}
                  />
                </Col>
                <Col>
                  <Button onClick={this.handleNewContact}>Add</Button>
                </Col>
              </Row>
            ) : (
              ''
            )}
            <div className='home-buttons d-flex w-100 justify-content-between px-3'>
              <Button theme='danger' name='dismiss' onClick={closeModal}>
                Dismiss
              </Button>
              {company.id && company.id.length > 0 ? (
                <Button
                  theme='warning'
                  name='dismiss'
                  onClick={() => deleteCompany(company)}
                >
                  Delete Company
                </Button>
              ) : (
                ''
              )}

              <Button
                theme='success'
                type='submit'
                className='text-center'
                disabled={pristine || submitting || invalid}
              >
                {company.name ? 'Update Company' : 'Add Company'}
              </Button>
            </div>
            <div className='text-center mx-auto'>
              {error && <label className='error-label'>{error}</label>}
            </div>
          </Form>
        </ModalBody>
      </Modal>
    );
  }
}

export default compose(
  connect(mapState, actions),
  reduxForm({ form: 'newCompanyForm', validate })
)(AddNewCompany);
